import cx from 'classnames';
import React, { ReactElement, ReactNode } from 'react';
import { Arrow, useHover, useLayer } from 'react-laag';
import { PlacementType } from 'react-laag/dist/PlacementType';

type Props = {
  tooltip: ReactNode;
  background?: string;
  children: ReactElement;
  placement?: PlacementType;
  shouldShow?: boolean;
  childClassName?: string;
  tooltipClassName?: string;
  tooltipTag?: 'p' | 'div';
  className?: string;
};

export const Tooltip = ({
  tooltip,
  background,
  children,
  placement,
  shouldShow = true,
  tooltipClassName,
  childClassName,
  tooltipTag = 'p',
  className,
}: Props) => {
  const [isOver, hoverProps] = useHover({ delayEnter: 100, delayLeave: 300 });

  const { triggerProps, layerProps, renderLayer, arrowProps } = useLayer({
    isOpen: isOver && shouldShow,
    auto: true,
    placement: placement || 'bottom-center',
    triggerOffset: 8,
  });

  const TooltipTag = tooltipTag;

  return (
    <>
      {shouldShow &&
        isOver &&
        renderLayer(
          <div
            {...layerProps}
            className={cx('z-[2000]', className)}
            data-tooltip
          >
            <div
              role="tooltip"
              className={cx(
                background ? background : 'bg-gray-800',
                'rounded p-3 shadow-md max-w-lg items-center',
                tooltipClassName,
              )}
            >
              <TooltipTag className="font-inter text-xs text-white mb-0">
                {tooltip}
              </TooltipTag>
              <Arrow
                {...arrowProps}
                backgroundColor={background || '#2c3242'}
                size={5}
              />
            </div>
          </div>,
        )}
      <span {...triggerProps} {...hoverProps} className={childClassName}>
        {children}
      </span>
    </>
  );
};
